export default __webpack_public_path__ + "media/images/coingecko-greyscale-d935e246.png";